<template>
  <div class='generic-properties'>
    <domain-node-properties
      v-if='getPropertiesType().domain === dataType'
      :data='data'
    />
    <threat-canvas-properties
      v-if='getPropertiesType().canvas === dataType'
      :data='data'
      @property-changed='propertyChanged'
    />
    <email-node-properties
      v-if='getPropertiesType().email === dataType'
      :data='data'
      @property-changed='propertyChanged'
    />
    <i-p-node-properties
      v-if='getPropertiesType().ip === dataType'
      :data='data'
      @property-changed='propertyChanged'
    />
    <subdomain-node-properties
      v-if='getPropertiesType().subdomain === dataType'
      :data='data'
      @property-changed='propertyChanged'
    />
    <custom-node-properties
      v-if='getPropertiesType().custom === dataType'
      :data='data'
      @property-changed='propertyChanged'
    />
    <custom-link-properties
      v-if='getPropertiesType().link === dataType'
      :data='data'
      @property-changed='propertyChanged'
    />
    <wrapper-node-properties
      v-if='getPropertiesType().subdomains_wrapper === dataType || getPropertiesType().email_wrapper === dataType'
      :data='data'
      @property-changed='propertyChanged'
    />
  </div>
</template>
<script>
import propertyTypes, { extendedPropertyTypes } from '@/constants/threatCanvas';
import DomainNodeProperties from '@/components/threat-canvas/DomainNodeProperties.vue';
import ThreatCanvasProperties from '@/components/threat-canvas/ThreatCanvasProperties.vue';
import EmailNodeProperties from '@/components/threat-canvas/EmailNodeProperties.vue';
import SubdomainNodeProperties from '@/components/threat-canvas/SubdomainNodeProperties.vue';
import CustomNodeProperties from '@/components/threat-canvas/CustomNodeProperties.vue';
import IPNodeProperties from '@/components/threat-canvas/IPNodeProperties.vue';
import CustomLinkProperties from '@/components/threat-canvas/CustomLinkProperties.vue';
import WrapperNodeProperties from '@/components/threat-canvas/WrapperNodeProperties.vue';

export default {
  name: 'GenericProperties',
  components: {
    IPNodeProperties,
    ThreatCanvasProperties,
    DomainNodeProperties,
    EmailNodeProperties,
    SubdomainNodeProperties,
    CustomNodeProperties,
    CustomLinkProperties,
    WrapperNodeProperties,
  },
  props: {
    data: {
      type: Object,
      required: false,
      default: () => ({type: 'none'}),
    },
  },
  computed: {
    dataType() {
      if (!this.data) return '';
      if (this.data.type) return this.data.type;
      if (this.data.properties && this.data.properties.type) return this.data.properties.type;
      return '';
    },
  },
  methods: {
    getPropertiesType() {
      return {...propertyTypes, ...extendedPropertyTypes};
    },
    propertyChanged(payload) {
      this.$emit('property-changed', { ...payload });
    },
  },
};
</script>
<style scoped lang='scss'>
@import '~@/assets/styles/design-system';
.generic-properties{
  display: flex;
  flex-direction: column;
  margin-top: rem(15);
  margin-right: rem(10);
  &__header{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    margin-left: rem(10);
    &__title{
      display: flex;
      flex-direction: column;
      margin-left: rem(15);
      &__name{
        color: var(--text-primary);
        font-family: $font-family-regular;
        font-size: rem(16);
        font-weight: bold;
        letter-spacing: 0;
        line-height: rem(17);
      };
      &__type{
        color: var(--text-tertiary);
        font-family: $font-family-regular;
        font-size: rem(10);
        letter-spacing: 1.1px;
        line-height: rem(15);
        margin-top: rem(5);
        text-transform: uppercase;
      };
    };
  }
}
</style>
